import { Product } from '@virginexperiencedays/products';
import { default as Component } from '../../SEO/SEO';
import config from '../../SEO/structured_data.config.json';
import { buildMetaRobotsContent } from '../../SEO/utils/buildMetaRobotsContent';
import { getMetaTitle } from '../../SEO/utils/metadata';

const SEO = ({
  product,
  pagePathOverride,
  metaRobots,
}: {
  product: Product;
  pagePathOverride?: string;
  metaRobots?: string;
}) => {
  const {
    title = null,
    media,
    url: productUrl,
    seo: { title: titleOverride = null, description = null } = {
      title: null,
      description: null,
    },
  } = product;

  const { website } = config;

  const pageUrl = website?.url?.replace(/\/$/, '');
  const url = pagePathOverride ? `${pageUrl}${pagePathOverride}` : productUrl;

  const productTitle = titleOverride && titleOverride !== title ? titleOverride : title;
  const metaTitle = getMetaTitle(productTitle);
  const metaDescription = description?.length
    ? description
    : `If you're looking for gift ideas then Virgin Experience can offer a wide range of different kinds of gift experiences such as ${title}`;

  const ogImage = media?.mainImage?.url || media?.images?.[0]?.url;

  return (
    <Component
      meta_title={metaTitle}
      meta_description={metaDescription}
      canonical={!metaRobots?.includes('noindex') ? url : undefined}
      meta_properties={[
        metaProp('og:locale', 'en_GB'),
        metaProp('og:type', 'website'),
        url && metaProp('og:url', url),
        ogImage && metaProp('og:image', ogImage),
        metaProp('og:site_name', 'Virgin Experience Days'),
        metaName('twitter:card', 'summary_large_image'),
        metaName('twitter:title', metaTitle),
        metaName('twitter:description', metaDescription),
        metaName('twitter:site', 'https://twitter.com/virginexp'),
        metaName('twitter:creator', '@virginexp'),
        ogImage && metaName('twitter:image', ogImage),
        metaName('robots', buildMetaRobotsContent(metaRobots)),
      ].filter((prop) => prop)}
    ></Component>
  );
};

const metaProp = (property: string, content: string) => ({
  property,
  content,
});
const metaName = (name: string, content: string) => ({
  name,
  content,
});

export default SEO;
